import { SET_STATUS_FILTERS } from './mutation-types'

const state = {
  statuses: [
    {
      label: 'Not yet submitted',
      value: 'wip',
      selected: true,
    },
    {
      value: 'missing',
      label: 'Input required',
      selected: true,
    },
    {
      value: 'inreview',
      label: 'In Review',
      selected: true,
    },
    {
      value: 'readytopublish',
      label: 'Proposal ready',
      selected: true,
    },
    {
      value: 'qualified',
      label: 'Promoted',
      selected: true,
    },
    {
      value: 'archived',
      label: 'Archived',
      selected: false,
    },
    {
      label: 'Reserved',
      value: 'reserve',
      selected: true,
    },
    {
      label: 'Withdrawn',
      value: 'withdrawn',
      selected: false,
    },
    {
      label: 'Success',
      value: 'success',
      selected: false,
    },
    {
      label: 'Closed',
      value: 'closed',
      selected: false,
    },
  ],
}

const mutations = {
  [SET_STATUS_FILTERS](state, data) {
    state.statuses = data
  },
}

const actions = {
  setStatusFilters({ commit }, payload) {
    commit(SET_STATUS_FILTERS, payload)
  },
}

const getters = {
  statusFilters: state => state.statuses,
  statusList: state => {
    const list = state.statuses.filter(i => i.selected).map(i => i.value)
    // workaround to have qualified and published mapped to the same
    if (list.includes('qualified') && !list.includes('published')) {
      list.push('published')
    }
    return list
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
